/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_bookmark__iti_save_error = /** @type {(inputs: {}) => string} */ () => {
	return `Die Route konnte nicht zu den Favoriten hinzugefügt werden.`
};

const en_bookmark__iti_save_error = /** @type {(inputs: {}) => string} */ () => {
	return `This route couldn't be added to your favourites`
};

const es_bookmark__iti_save_error = /** @type {(inputs: {}) => string} */ () => {
	return `No se ha podido añadir este itinerario a favoritos.`
};

const fr_bookmark__iti_save_error = /** @type {(inputs: {}) => string} */ () => {
	return `Cet itinéraire n'a pas pu être ajouté aux favoris.`
};

const it_bookmark__iti_save_error = /** @type {(inputs: {}) => string} */ () => {
	return `Impossibile aggiungere l'itinerario ai preferiti.`
};

const nl_bookmark__iti_save_error = /** @type {(inputs: {}) => string} */ () => {
	return `Deze route kon niet aan favorieten worden toegevoegd.`
};

const pt_bookmark__iti_save_error = /** @type {(inputs: {}) => string} */ () => {
	return `Este itinerário não pôde ser adicionado aos favoritos.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__iti_save_error = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bookmark__iti_save_error(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("bookmark__iti_save_error", locale)
	if (locale === "de") return de_bookmark__iti_save_error(inputs)
	if (locale === "en") return en_bookmark__iti_save_error(inputs)
	if (locale === "es") return es_bookmark__iti_save_error(inputs)
	if (locale === "fr") return fr_bookmark__iti_save_error(inputs)
	if (locale === "it") return it_bookmark__iti_save_error(inputs)
	if (locale === "nl") return nl_bookmark__iti_save_error(inputs)
	return pt_bookmark__iti_save_error(inputs)
};